import { useMemo } from "react";
import type { Recipe } from "@/features/Recipes-renamed/types";
import { useFavoriteRecipes } from "./useFavoriteRecipes";

interface SampleResult {
    data: Recipe[];
    isLoading: boolean;
    isError: boolean;
}

export function useFavoriteRecipesSample(count: number): SampleResult {
    const { data, isLoading, isError } = useFavoriteRecipes();
    const sample = useMemo(() => (data ? data.slice(0, count) : []), [data, count]);
    return { data: sample, isLoading, isError };
}
